import GokuDataGrid from '@/components/GokuDataGrid'
import { useModal } from '@/contexts/modal'
import { DocumentModalProps } from '@/modals/DocumentModal'
import { getDocumentShareWithMe } from '@/modules/Documents/services'
import { Documents } from '@/modules/Documents/types/reponse'
import { IPermissionProps } from '@/types/shared'
import { documentListColumn } from '../../List/column'
import Filters from '../../shared/Filters'
import { useTranslation } from 'react-i18next'

const ShareWithMe: React.FC<IPermissionProps> = () => {
    const { setModal } = useModal()
    const { t } = useTranslation()

    const handleSelectDocument = (row: Documents) => {
        setModal<DocumentModalProps>('DocumentModal/index', {
            title: row?.name_file,
            description: row?.descriptions,
            versions: row?.versions,
        })
    }
    return (
        <>
            <div className="my-2">
                <GokuDataGrid
                    apiCall={getDocumentShareWithMe}
                    reactQueryKey="document-shared-with-me"
                    columns={documentListColumn(t, handleSelectDocument)}
                    actions={[]}
                    options={{
                        showSearch: true,
                        showHideColumn: true,
                        pageSize: 10,
                        title: '',
                    }}
                    searchPlaceholder="Search theo tên , mô tả..."
                    dataGridProps={{
                        getRowId: (row) => row?.document_id,
                    }}
                    filterDefaultValues={{
                        employee_id: [],
                        document_type: [],
                        document_level: [],
                        start_day: [],
                        end_day: [],
                    }}
                >
                    {({ control }) => {
                        return <Filters control={control} />
                    }}
                </GokuDataGrid>
            </div>
        </>
    )
}

export default ShareWithMe
